import { render, staticRenderFns } from "./onlineVideoAdd.vue?vue&type=template&id=7cffdb34&"
import script from "./onlineVideoAdd.vue?vue&type=script&lang=js&"
export * from "./onlineVideoAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports